import axios from 'axios'

import {types} from '../../actions'
import $ from "jquery";

export const form_methods = {
    computed: {
        local_config(){
            return this.$store.state.stages[this.$store.state.active_view]
        },
    },
    methods: {
        send_form(){



            axios.post(this.$store.state.API_ROUTE + this.$store.state.stages[this.this_page].all.methods.post.url, this.$store.getters.form_data)
              .then((response) => {

                  if(response.data.status === 'ok'){

                      this.$store.dispatch(types.FIND_AND_SAVE,response)
                      this.$store.commit('save_optional_data',{type:'form',data: response.data.data})

                      this.redirect(response.data.redirect_to)

                  }

              })
              .catch((error) => {

                  this.show_errors(error)

                  if(error.response.data.status === 'error'){

                      this.$store.commit('save_form_errors',{stage:this.this_page,data:error.response.data.errors})

                  }

              });

        },
        select2_init(){
            let state_input = $('select[name="state"]');
            if(state_input.length){
                $('select').select2({
                    minimumResultsForSearch: -1, //** hide default plugin search input
                });

                state_input.on('change', (e)=>{ //** listener on hidden <select> value
                    this.state = $(e.target).val()
                })

            }
        },
        mask_init: function(){
            // let zip_input = $('input[name=zipcode]');
            // if (zip_input.length) {
            //     zip_input.mask("00000", {placeholder: $('input[name=zipcode]').attr('placeholder')});
            // }

            // let phone_input = $('input[name=phone]');
            // if (phone_input.length) {
            //     phone_input.mask("000-000-0000", {placeholder: $('input[name=phone]').attr('placeholder')});
            // }
        },
    },
    created(){

    },
    mounted(){
        //this.select2_init()

        // this.mask_init()
    }
}